export const BONUS_MULTIVIEW = 'bonus-multi-view';
